import styled from 'styled-components';
import CloseIconMDI from 'mdi-react/CloseCircleOutlineIcon';
import { layout, media, brandColors, colorUtils } from 'src/components/base';

const searchHeightMobile = layout.searchBar.height.mobile.value;
const searchHeight = layout.searchBar.height.desktop.value;

type BlockProps = { hasResults?: boolean };
export const Block = styled.div<BlockProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${searchHeight}px;
  overflow: hidden;
  position: relative;
  border-radius: ${layout.borderRadius};
  background: white;

  ${p =>
    p.hasResults
      ? `border-radius: ${layout.borderRadius} ${layout.borderRadius} 0px 0px;`
      : ''}

  ${media.smallOnly`
    height: ${searchHeightMobile}px;
  `}
`;

export const Input = styled.input`
  background: transparent;
  border: none;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  padding: 0.5rem 10px;
  border-radius: 5px;

  &:focus {
    outline: none;
  }
`;

export const FullSearchButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  height: ${searchHeight - 10}px;
  margin: -0.2rem;
  padding: 0 20px;
  border-top-right-radius: ${layout.borderRadius};
  border-bottom-right-radius: ${layout.borderRadius};
  background: ${p => colorUtils.setRgbaAlpha(p.theme.bg.secondary, 0)};
  border-left: 1px solid ${p => p.theme.colors.base200};

  ${media.smallOnly`
    height: ${searchHeightMobile - 10};
    padding: 0 10px;
  `}

  svg path {
    fill: ${colorUtils.shadeColor(brandColors.pricespy, 15)};
  }
`;
type ClearButtonProps = {
  visible: string;
};
export const ClearButton = styled.button<ClearButtonProps>`
  font-size: 19px;
  padding: 0.6rem;
  visibility: hidden;
  outline: none;

  ${p => (p.visible ? 'visibility: visible;' : '')}
`;

export const CloseIcon = styled(CloseIconMDI).attrs(p => ({
  color: p.theme.icons.tertiary,
}))``;
